import React from 'react';
import T from 'prop-types';
// icons
import { ReactComponent as CloseIcon } from 'icons/close.svg';
// styles
import classnames from 'classnames/bind';
import styles from './Button.module.scss';

const cx = classnames.bind(styles);

const VARIANTS = ['primary', 'light', 'white'];

const CloseButton = ({ onClick, variant = 'primary', className, ...props }) => {
  return (
    <div role="button" className={cx('close-button', `bg-${variant}`, className)} onClick={onClick} {...props}>
      <CloseIcon />
    </div>
  );
};

CloseButton.propTypes = {
  onClick: T.func.isRequired,
  variant: T.oneOf(VARIANTS),
  className: T.string,
};

export default CloseButton;
